(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"] && !Shopify.designMode) return;
  try {
    
(function () {
  try {
    var sectionId = 'flk-product-grid-{{ section.id }}';
    var root = document.getElementById(sectionId);
    // if root missing, still bind to document to cover editor preview
    root = root || document;

    function isInteractive(el){
      return el && el.closest && !!el.closest('a, button, input, select, textarea, label, [role="button"], .flk-atc-btn, .swatch, .product-form');
    }
    function buildAbsolute(url){
      if(!url) return url;
      try { if(url.charAt(0) === '/') return new URL(url, window.location.origin).href; } catch(e){}
      return url;
    }
    function navigateTo(url){
      if(!url) return;
      window.location.assign(buildAbsolute(url));
    }

    function docCaptureHandler(e){
      try {
        if(e.defaultPrevented) return;
        var target = e.target;
        var card = target.closest && target.closest('.flk-card');
        if(!card) return;
        if(isInteractive(target)) return;
        if(target.closest && target.closest('a, button')) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        var url = card.dataset.productUrl;
        navigateTo(url);
      } catch(err){}
    }

    function onCardClick(e){
      try {
        if(e.defaultPrevented) return;
        if(e.button && e.button !== 0) return;
        if(isInteractive(e.target)) return;
        var card = this;
        var url = card.dataset.productUrl;
        navigateTo(url);
      } catch(err){}
    }
    function onCardKeydown(e){
      try {
        if(e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar'){
          e.preventDefault();
          var url = this.dataset.productUrl;
          navigateTo(url);
        }
      } catch(err){}
    }

    function bindCards(scope){
      scope = scope || document;
      var cards = (scope.querySelectorAll && scope.querySelectorAll('.flk-card')) || [];
      cards.forEach(function(card){
        if(card.__flkBound) return;
        card.addEventListener('click', onCardClick, false);
        card.addEventListener('keydown', onCardKeydown, false);
        card.style.cursor = 'pointer';
        if(!card.hasAttribute('tabindex')) card.setAttribute('tabindex','0');
        if(!card.hasAttribute('role')) card.setAttribute('role','link');
        card.__flkBound = true;
      });
    }

    if(!window.__flk_capture_installed){
      document.addEventListener('click', docCaptureHandler, true);
      window.__flk_capture_installed = true;
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function(){ bindCards(root); });
    } else {
      bindCards(root);
    }

    try {
      var moRoot = document.getElementById('flk-product-grid-{{ section.id }}') || document.body;
      var mo = new MutationObserver(function(muts){
        muts.forEach(function(m){
          if(m.addedNodes && m.addedNodes.length){
            bindCards(m.target || document);
          }
        });
      });
      mo.observe(moRoot, { childList: true, subtree: true });
    } catch(err){}

    window.__flk_debug = function(){
      var rows = [];
      document.querySelectorAll('.flk-card').forEach(function(c){
        rows.push({ id: c.dataset.productId, url: c.dataset.productUrl, bound: !!c.__flkBound });
      });
      console.log('FLK debug:', rows);
      return rows;
    };

  } catch(e){}
})();

  } catch(e) { console.error(e); }
})();
})();
